// extracted by mini-css-extract-plugin
module.exports = {"startGameButton":"Mode_startGameButton__3cnuo","homeContainer":"Mode_homeContainer__3gfTp","heroContainer":"Mode_heroContainer__3pJN2","storyList":"Mode_storyList__Rwst-"};